import styled from 'styled-components';
import colors from '../../../../styles/colors';

const AltroButtonStatsMobileContainer = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const ContainerButtonMobile = styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
    background-color: ${colors.bgColorBlack2};
    color: white;
    border-radius: 10px;

    &:hover {
        background-color: ${colors.bgColorBordeaux};
    }

    & .title-button-mobile {
        margin: 0;
        padding: 0;
        font-size: 10px;
        font-weight: 800;
        color: white;
        text-align: center;
        width: 100%;
        text-transform: uppercase;
        text-overflow: ellipsis;
        overflow: hidden;
        letter-spacing: 2px;
    }
`;

const AltroButtonStatsMobile = ({ title, onClick }) => {
    return (
        <AltroButtonStatsMobileContainer className='altro-button-stats-mobile-container'>
            <ContainerButtonMobile className='container-button-mobile' onClick={onClick}>
                <h3 className='title-button-mobile'>{title}</h3>
            </ContainerButtonMobile>
        </AltroButtonStatsMobileContainer>
    );
};

export default AltroButtonStatsMobile;